export const css = {
	root: '_3rQfdm-X',
	close: '_3l6LbVcd',
	indicator: '_70PhFZHG',
	tabButtons: '_3jgQafC8',
	tabButton: 'pJwI4Fz0',
	disabledTabButton: '_3lRtcxK2',
	activeTabButton: 'HMw3oeEW',
	closeable: '_3GtSyOPt',
	tab: 'lAvduE_a',
	alignLeft: '_1GgKtwT1',
	alignRight: '_14LFKC1R',
	tabs: 'qrYX4pSK',
	alignBottom: '_1Oq3vhtz',
	indicatorActive: '_26B7Wxt3',
	indicatorContent: 'TNRbNFt2',
	tabButtonContent: '_3ZrZlibQ',
	' _key': 'base-widgets/tab-container'
};

export default css;
